<template>
    <div class="monitoringBigData_box">
        <div class="search-form">
            <el-form ref="form" :model="queryForm"  :inline="true" label-position="left">
                <el-form-item label="数据查询范围：" prop="organizationId">
                <el-select v-model="queryForm.organizationId" placeholder="请选择" style="width: 240px">
                    <el-option v-for="item in selectList" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
                </el-form-item>
                <el-form-item label="时间范围：" prop="day">
                <el-select v-model="queryForm.day" placeholder="请选择" style="width: 140px">
                    <el-option v-for="item in dataRangeList" :key="item.value" :label="item.name" :value="item.value" />
                </el-select>
                </el-form-item>
                <el-form-item label="开始时间：" style="width: 260px;" :label-width="100" v-if="queryForm.day==6">
                    <el-date-picker
                    value-format="YYYY-MM-DD"
                    clearable           
                    v-model="queryForm.StartDate"
                    type="date"
                    placeholder="请选择"
                    :disabled-date="disabledDateOneYear"
                    />
                </el-form-item>
                <el-form-item label="结束时间：" style="width: 260px;" :label-width="100" v-if="queryForm.day==6">
                    <el-date-picker
                    value-format="YYYY-MM-DD"
                    clearable
                    v-model="queryForm.EndDate"
                    type="date"
                    placeholder="请选择"
                    :disabled-date="disabledDateOneYear"
                />
                </el-form-item>
                <el-form-item label="">
                <MyButton icon="Search" @click="initData">查询</MyButton>
                </el-form-item>
                <el-form-item label="">
                <MyButton icon="Refresh" @click="RefreshData">重置</MyButton>
                </el-form-item>
            </el-form>
        </div>
        <div class="monitoringBigData">
            <div class="monitoringBigData_left">
                <div class="left_top">
                <div class="title_box">
                    <el-icon color="#2CD7EF" :size="20"><ArrowRightBold /></el-icon>
                    <div class="title">人员进入</div>
                </div>
                <Chart1 :data="arr"></Chart1>
                </div>
                <div class="left_bottom">
                <div class="title_box">
                    <el-icon color="#2CD7EF" :size="20"><ArrowRightBold /></el-icon>
                    <div class="title">监控预警</div>
                </div>
                <div class="content" @click="openPersonnelListVisible">
                    <div class="content_val">
                        <div class="val">{{ monitoringList.warningCount||0 }}</div>
                        <div class="text">实时报警数量</div>
                    </div>
                        <div class="content_val val_12">
                        <div class="val" style="color: #F3A129;">{{ monitoringList.nonWarningCount||0 }}</div>
                        <div class="text">未报警数量</div>
                    </div>
                    <div class="content_val">
                        <div class="val" style="color:#67C23A;">{{ monitoringList.totalCount||0 }}</div>
                        <div class="text">总数</div>
                    </div>
                </div>
                <Chart2 :data="monitoringList" :oldData="lastMonthList" :timeType="queryForm.day" :timeDay="timeDay"></Chart2>
                </div>
            </div>
            <div class="monitoringBigData_middle">
                <div class="middle_top">
                  <div class="top_progress">
                        <el-progress type="dashboard" :percentage="progressNum" :stroke-width="16" :width="300">
                            <template #default="{ percentage }">
                                <div class="progress_circle">
                                    <div class="circle_text">今日检测人次数</div>
                                    <div class="circle_percentage">
                                        <div class="percentage_val" v-if="count[0]!='无'">{{count[0]}}</div>
                                        <div v-else class="percentage_val val_wu">
                                             {{ count[0] }}
                                        </div>
                                        <div class="percentage_val percentage_left" v-if="count[1]!='无'">{{count[1]}}</div>
                                        <div v-else class="percentage_val percentage_left val_wu">
                                             {{ count[1] }}
                                        </div>
                                        <div class="percentage_val percentage_right" v-if="count[2]!='无'">{{count[2]}}</div>
                                        <div v-else class="percentage_val percentage_right val_wu">
                                             {{ count[2] }}
                                        </div>
                                        <div class="percentage_val" v-if="count[3]!='无'">{{count[3]}}</div>
                                         <div v-else class="percentage_val val_wu">
                                             {{ count[3] }}
                                        </div>
                                    </div>
                                    <div class="circle_val">全司人次数：{{totalPeople}}</div>
                                </div>
                            </template>
                        </el-progress>
                        <div class="top_svg">
                          <svg width="360" height="360" viewBox="0 0 200 200">
                                <defs>
                                    <radialGradient id="gearGradient" cx="50%" cy="50%" r="50%">
                                    <stop offset="0%" stop-color="#8D6EF6" />
                                    <stop offset="100%" stop-color="#1EC4FA" />
                                    </radialGradient>
                                </defs>
                                <path d="M 55 177.94 
                                        A 90 90 0 1 1 145 177.94" 
                                        fill="none" 
                                        stroke="#32A2F8" 
                                        stroke-width="6" 
                                        stroke-dasharray="3 5" />
                                </svg>
                        </div>
                    </div>
                </div>
                <div class="middle_bottom">
                    <div class="middle_title">
                        <el-icon color="#2CD7EF" :size="20"><ArrowRightBold /></el-icon>
                        <div class="title title_center">监控异常</div>
                        <el-icon color="#2CD7EF" :size="20"><ArrowLeftBold /></el-icon>
                    </div>
                    <Chart4 :timeList="TimeList"></Chart4>
                </div>
            </div>
            <div class="monitoringBigData_right">
                <div class="box_list">
                  <div class="title_box">
                    <el-icon color="#2CD7EF" :size="20"><ArrowRightBold /></el-icon>
                    <div class="title">预警记录</div>
                </div>
                    <div v-if="WarningRecordList.length>0" ref="warnScrollRef" class="list_box">
                        <div class="list_item">
                            <div class="list" v-for="(item,index) in WarningRecordList" :key="index">
                                <div class="list_left">
                                    <div v-if="!item.faceEvaluationData">
                                        <el-icon :size="60"><Avatar/></el-icon>
                                    </div>
                                    <div v-else>
                                        <el-avatar :size="60" :src="`data:image/png;base64,${item.faceEvaluationData}`" />
                                    </div>
                                    <div class="left_text">姓名：{{ item.testerName }}</div>
                                </div>
                                <div class="list_right">
                                    <div class="right_val">
                                        <div class="val_width">岗位：</div>
                                        <div class="val_size">{{item.career==null?'未知':item.career}}</div>
                                    </div>
                                    <div class="right_val">
                                        <div class="val_width">压力程度：</div>
                                        <el-progress :percentage="item.stress" :format="format" :stroke-width="10" :color="item.stressColor"/>
                                    </div>
                                    <div class="right_val">
                                        <div class="val_width">紧张程度：</div>
                                        <el-progress :percentage="item.tension" :format="format" :stroke-width="10" :color="item.tensionColor"/>
                                    </div>
                                    <div class="right_val">
                                        <div class="val_width">冲动倾向：</div>
                                        <el-progress :percentage="item.anger" :format="format" :stroke-width="10" :color="item.angerColor"/>
                                    </div>
                                    <div class="right_val">
                                        <div class="val_width">情绪偏离：</div>
                                        <el-progress :percentage="item.suspect" :format="format" :stroke-width="10" :color="item.suspectColor"/>
                                    </div>
                                    <div class="right_val">
                                        <div class="val_width">睡眠状态：</div>
                                        <el-progress :percentage="item.sleepHealth" :format="format" :stroke-width="10" :color="item.sleepHealthColor"/>
                                    </div>
                                    <div class="right_val">
                                        <div class="val_width">进入时间：</div>
                                        <div class="val_size">{{ dayjs(item.creationTime??item.evaluationTime).format('YYYY-MM-DD HH:mm:ss') }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="NoMore" v-if="WarningRecordList.length >= warnTotal">没有更多数据了</div>
                        </div>
                    </div>
                    <div v-else>
                             <el-empty :image-size="50" description="暂无数据" />
                    </div>
                </div>
                <div class="box_table">
                    <div class="table_head">
                        <div>员工</div>
                        <div>部门</div>
                        <div>预警类别</div>
                    </div>
                    <div class="table_content" ref="scrollRef">
                        <div v-if="personnelList.length>0">
                            <div class="content_item" v-for="(item,index) in personnelList" :key="index">
                                <div>{{ item.testerName }}</div>
                                <div>{{item.departmentName==null?'无':item.departmentName}}</div>
                                <div>情绪偏离：{{ item.suspect.toFixed(2) }}</div>
                            </div>
                            <div class="NoMore" v-if="personnelList.length >= totalCount">没有更多数据了</div>
                        </div>
                        <div v-else>
                             <el-empty :image-size="50" description="暂无数据" />
                        </div>
                    </div>
                </div>
            </div>
            <div style="width: 0; height: 0">
                <svg>
                    <defs>
                    <linearGradient id="myGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stop-color="#8D6EF6" />
                        <stop offset="100%" stop-color="#1EC4FA" />
                    </linearGradient>
                    </defs>
                </svg>
            </div>

        </div>
        <Dialog
        width="80%"
        v-model="PersonnelListVisible"
        title="人员列表"
        top="5vh"
        body-bg-color="var(--themed-color2)"
        >
           <MyTable :table-options="tableOptions" border max-height="60vh">
           </MyTable>
           <MyPagination :params="paginationParams" :total="total" @get-list="isgetTesterThreeSecondsEvaluationData" ref="paginationRef" />
        </Dialog>
    </div>
</template>

<script setup>
import Chart1 from "./Chart1"
import Chart2 from "./Chart2"
import Chart4 from "./Chart4"
import dayjs from 'dayjs';
import { local } from "@/utils/storage.js";
import MyTable from "@/components/Global/MyTable.vue";
import MyPagination from "@/components/Global/MyPagination.vue";
import { reactive, ref, onMounted, onUnmounted, nextTick, watch } from "vue";
import { ElMessage } from 'element-plus'
import organizationApi from "@/api/organization";
import * as signalR from '@microsoft/signalr'
import { postTestevaluation } from "@/api/monitor"
import { getPercentage, getRangeStartDate, getYearFirstLastDay, getOffsetDateRange, getDayDiff, getDateRange, isToday } from "@/utils/validate";
import { postchanneldetectionstatistics, postdetectionsummary, postwarningrecords, postWarningsummary, postwarninghourlystatistics, postThreesecondswarningorders, getTesterThreeSecondsEvaluation } from "@/api/threeStatistics"

// ===================== 定时器相关 =====================
let pollTimer = null
const POLL_INTERVAL = 60 * 1000 // 1分钟

// 启停轮询：仅当天(day=1)开启一分钟轮询，其他时间停止
function checkAndStartPoll() {
  if (pollTimer) {
    clearInterval(pollTimer)
    pollTimer = null
  }
  if (queryForm.day === "1") {
    RealinitData()
    pollTimer = setInterval(() => {
      RealinitData()
    }, POLL_INTERVAL)
  }
}

// 停止轮询
function stopPoll() {
  if (pollTimer) {
    clearInterval(pollTimer)
    pollTimer = null
  }
}
// =====================================================

const postTestevaluationData = () => {
  postTestevaluation().then(res => {
    console.log(res, "++++")
  })
}

// SignalR
let connection = null
const registerHandlers = () => {
  if (!connection) return
  connection.on('ReceiveEvaluation', (msg) => {
    WarningRecordList.value.unshift(msg)
    RealinitData()
    console.log(msg, '服务端数据')
  })
  connection.onclose(() => {
    console.log('连接已关闭')
  })
  connection.onreconnecting(() => {
    console.log('正在重连...')
  })
  connection.onreconnected(() => {
    console.log('重连成功')
  })
}

const startConnection = async () => {
  if (connection) return
  try {
    connection = new signalR.HubConnectionBuilder()
      .withUrl(`${window.global_config.BASE_URL}/faceNotifyHub?clientType=web`, {
        withCredentials: true
      })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build()
    registerHandlers()
    await connection.start()
    console.log('SignalR 连接成功')
  } catch (err) {
    console.error('SignalR 连接失败:', err)
  }
}

const format = (percentage) => {
  const val = Number(percentage) || 0
  return val === 100 ? '100' : val.toFixed(2)
}

const disabledDateOneYear = (time) => {
  const now = new Date()
  const oneYearAgo = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate())
  return time.getTime() > now.getTime() || time.getTime() < oneYearAgo.getTime()
}

const PersonnelListVisible = ref(false)
const dataRangeList = [
  { name: "当天", value: "1" },
  { name: "1个月", value: "month" },
  { name: "3个月", value: "3month" },
  { name: "6个月", value: "6month" },
  { name: "1年", value: "year" },
  { name: "自定义", value: "6" }
]

const getNowDate = () => {
  const d = new Date();
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

const queryForm = reactive({
  organizationId: "",
  StartDate: "",
  EndDate: "",
  day: "1",
})

const selectList = ref([]);
// 改为 async 函数，返回 Promise，保证异步执行顺序
const getSelectList = async () => {
  const res = await organizationApi.getUnitList({
    SkipCount: 0,
    MaxResultCount: 1000,
  })
  selectList.value = res.data.items.map((item) => {
    return {
      label: item.name,
      value: item.id,
      ...item
    }
  })
  if (selectList.value.length > 0) {
    queryForm.organizationId = selectList.value[0].id
    // 待选中的id，从本地缓存读取
    const targetSelectId =local.get('isId')
    if(targetSelectId){
      queryForm.organizationId=targetSelectId
    }
  }
}

// 人员进出
const arr = ref([
  { channelId: '1', channelName: "通道", accessWay: 0, accessWayText: "进", detectionCount: 0 },
  { channelId: '1', channelName: "通道", accessWay: 1, accessWayText: "出", detectionCount: 0 },
])

const postchanneldetectionstatisticsData = (organizationId, startTime, endTime) => {
  let obj = {
    organizationId: organizationId,
    startTime: startTime + " " + "00:00:00",
    endTime: endTime + " " + "23:59:59",
  }
  postchanneldetectionstatistics(obj).then(res => {
    console.log(res, "进出")
    if (res.data.length > 0) {
      arr.value = res.data
    } else {
      arr.value = [
        { channelId: '1', channelName: "通道", accessWay: 0, accessWayText: "进", detectionCount: 0 },
        { channelId: '1', channelName: "通道", accessWay: 1, accessWayText: "出", detectionCount: 0 },
      ]
    }
  })
}

// 实际检测人数
const count = ref(["0", "0", "0", "0"])
const splitToArray = (num) => {
  let str = String(num ?? 0);
  if (str.length > 4) {
    str = str.slice(-4);
  }
  while (str.length < 4) {
    str = '0' + str;
  }
  return str.split('');
}

const postdetectionsummaryData = async (organizationId, startTime, endTime) => {
  let obj = {
    organizationId: organizationId,
    startTime: startTime + " " + "00:00:00",
    endTime: endTime + " " + "23:59:59",
  }
  let res = await postdetectionsummary(obj)
  console.log(res, "实际检测人数")
  count.value = splitToArray(res.data.evaluationCount)
  return res.data.evaluationCount
}

// 预警记录滚动
const warnScrollRef = ref(null)
const warnPage = reactive({
  page: 1,
  size: 5,
  loading: false
})
const WarningRecordList = ref([])
const warnTotal = ref(0)

const handleWarnScroll = async () => {
  const dom = warnScrollRef.value
  if (!dom) return
  if (isToday(StartDate.value)) {
    return
  }

  let Start = ""
  let End = ""
  if (queryForm.day == 6) {
    Start = queryForm.StartDate
    End = queryForm.EndDate
  } else if (queryForm.day == "year") {
    let time = getYearFirstLastDay()
    Start = time.firstDay
    End = time.lastDay
  } else {
    Start = getRangeStartDate(getNowDate(), queryForm.day)
    End = getNowDate()
  }

  const { scrollTop, scrollHeight, clientHeight } = dom
  if (scrollTop + clientHeight >= scrollHeight - 10) {
    if (warnPage.loading) return
    if (WarningRecordList.value.length >= warnTotal.value) return
    warnPage.page++
    warnPage.loading = true
    await postwarningrecordsData(
      queryForm.organizationId,
      Start,
      End,
      true
    )
    warnPage.loading = false
  }
}

const postwarningrecordsData = async (organizationId, startTime, endTime, isLoadMore = false) => {
  let obj = {
    organizationId: organizationId,
    startTime: startTime + " 00:00:00",
    endTime: endTime + " 23:59:59",
    SkipCount: (warnPage.page - 1) * warnPage.size,
    MaxResultCount: warnPage.size,
  }
  const res = await postwarningrecords(obj)
  console.log(res, "预警记录")
  if (isToday(startTime)) {
    WarningRecordList.value = []
    return
  }
  warnTotal.value = res.data.totalCount
  if (isLoadMore) {
    WarningRecordList.value = [...WarningRecordList.value, ...res.data.items]
  } else {
    WarningRecordList.value = res.data.items
  }
  nextTick(() => {
    if (warnScrollRef.value) {
      warnScrollRef.value.removeEventListener('scroll', handleWarnScroll)
      warnScrollRef.value.addEventListener('scroll', handleWarnScroll)
    }
  })
}

// 监控预警
const monitoringList = ref({})
const lastMonthList = ref({})
const timeDay = ref(0)
const postWarningsummaryData = (organizationId, startTime, endTime) => {
  let obj = {
    organizationId: organizationId,
    startTime: startTime + " " + "00:00:00",
    endTime: endTime + " " + "23:59:59",
  }
  postWarningsummary(obj).then(res => {
    console.log(res, '监控预警')
    monitoringList.value = res.data
    if (queryForm.day == 6) {
      timeDay.value = getDayDiff(startTime, endTime)
      let d = getDateRange(startTime, timeDay.value)
      let obj2 = {
        organizationId: organizationId,
        startTime: d.targetDate + " " + "00:00:00",
        endTime: d.prevDate + " " + "23:59:59",
      }
      postWarningsummary(obj2).then(res1 => {
        lastMonthList.value = res.data
      })
    } else {
      let time = getOffsetDateRange(startTime + " " + "00:00:00", endTime + " " + "23:59:59", queryForm.day)
      let obj1 = {
        organizationId: organizationId,
        startTime: time.start,
        endTime: time.end,
      }
      postWarningsummary(obj1).then(res1 => {
        lastMonthList.value = res.data
      })
    }
  })
}

// 监控异常
const TimeList = ref([
  { "hour": 0, "warningCount": 0 },
  { "hour": 1, "warningCount": 0 },
  { "hour": 2, "warningCount": 0 },
  { "hour": 3, "warningCount": 0 },
  { "hour": 4, "warningCount": 0 },
  { "hour": 5, "warningCount": 0 },
  { "hour": 6, "warningCount": 0 },
  { "hour": 7, "warningCount": 0 },
  { "hour": 8, "warningCount": 0 },
  { "hour": 9, "warningCount": 0 },
  { "hour": 10, "warningCount": 0 },
  { "hour": 11, "warningCount": 0 },
  { "hour": 12, "warningCount": 0 },
  { "hour": 13, "warningCount": 0 },
  { "hour": 14, "warningCount": 0 },
  { "hour": 15, "warningCount": 0 },
  { "hour": 16, "warningCount": 0 },
  { "hour": 17, "warningCount": 0 },
  { "hour": 18, "warningCount": 0 },
  { "hour": 19, "warningCount": 0 },
  { "hour": 20, "warningCount": 0 },
  { "hour": 21, "warningCount": 0 },
  { "hour": 22, "warningCount": 0 },
  { "hour": 23, "warningCount": 0 }
])

const postwarninghourlystatisticsData = (organizationId, startTime, endTime) => {
  let obj = {
    organizationId: organizationId,
    startTime: startTime + " " + "00:00:00",
    endTime: endTime + " " + "23:59:59",
  }
  postwarninghourlystatistics(obj).then(res => {
    console.log(res, '监控异常')
    TimeList.value = res.data
  })
}

// 人员列表
const personnelList = ref([])
const totalCount = ref(0)
const scrollRef = ref(null)
const pageInfo = reactive({
  page: 1,
  size: 10,
  loading: false,
})

const handleScroll = async () => {
  const dom = scrollRef.value
  if (!dom) return
  const { scrollTop, scrollHeight, clientHeight } = dom
  if (scrollTop + clientHeight >= scrollHeight - 10) {
    if (pageInfo.loading) return
    if (personnelList.value.length >= totalCount.value) return
    pageInfo.page++
    pageInfo.loading = true
    await postThreesecondswarningordersData(
      queryForm.organizationId,
      queryForm.StartDate,
      queryForm.EndDate,
      true
    )
    pageInfo.loading = false
  }
}

const postThreesecondswarningordersData = async (organizationId, startTime, endTime, isLoadMore = false) => {
  let obj = {
    organizationId: organizationId,
    startTime: startTime + " 00:00:00",
    endTime: endTime + " 23:59:59",
    SkipCount: (pageInfo.page - 1) * pageInfo.size,
    MaxResultCount: pageInfo.size,
  }
  const res = await postThreesecondswarningorders(obj)
  console.log(res, "人员列表")
  totalCount.value = res.data.totalCount
  if (isLoadMore) {
    personnelList.value = [...personnelList.value, ...res.data.items]
  } else {
    personnelList.value = res.data.items
  }
}

// 公司总人数
const totalPeople = ref(0)
const getTesterThreeSecondsEvaluationData = async (organizationId) => {
  let obj = {
    organizationId: organizationId,
    IsNoList: true
  }
  let res = await getTesterThreeSecondsEvaluation(obj)
  console.log(res, "公司总人数")
  totalPeople.value = res.data.totalCount
  return res.data.totalCount
}

// 弹窗人员列表
const openPersonnelListVisible = async () => {
  if (!queryForm.organizationId) {
    return ElMessage.warning("请选查询数据范围")
  }
  PersonnelListVisible.value = true
  paginationParams.organizationId = queryForm.organizationId
  paginationParams.StartDate = StartDate.value
  paginationParams.EndDate = EndDate.value
}

const total = ref(0)
const paginationParams = reactive({
  organizationId: "",
  IsWarningOrder: true,
  StartDate: "",
  EndDate: "",
})
const paginationRef = ref(null)
const tableOptions = reactive({
  colList: [
    { label: "序号", type: "index", width: 60 },
    { label: "姓名", prop: "testerName" },
    { label: "年龄", prop: "age" },
    { label: "电话", prop: "phone" },
    { label: "性别", prop: "sexText" },
    { label: "职业/岗位", prop: "career" },
    { label: "部门", prop: "departmentName" },
    { label: "创建时间", prop: "creationTime" },
  ],
  tableData: [],
});

const isgetTesterThreeSecondsEvaluationData = (params = paginationRef?.value.getList_params) => {
  getTesterThreeSecondsEvaluation(params).then(res => {
    total.value = res.data.totalCount
    tableOptions.tableData = res.data.items
  })
}

const progressNum = ref(0)
const StartDate = ref(getNowDate() + " " + "00:00:00")
const EndDate = ref(getNowDate() + " " + "23:59:59")

const initData = async () => {
  pageInfo.page = 1
  warnPage.page = 1
  if (!queryForm.organizationId) {
    return ElMessage.warning("请选查询数据范围")
  }
  if (queryForm.day == 1) {
    StartDate.value = getNowDate()
    EndDate.value = getNowDate()
  } else if (queryForm.day == 6) {
    if (queryForm.StartDate && queryForm.EndDate) {
      StartDate.value = queryForm.StartDate
      EndDate.value = queryForm.EndDate
    } else {
      ElMessage.warning("开始时间和结束时间不能为空")
      return
    }
  } else if (queryForm.day == "year") {
    let time = getYearFirstLastDay()
    StartDate.value = time.firstDay
    EndDate.value = time.lastDay
  } else {
    StartDate.value = getRangeStartDate(getNowDate(), queryForm.day)
    EndDate.value = getNowDate()
  }

  let res = null
  let res2 = null
  let res6 = null
  res = await Promise.allSettled(
    [
      postchanneldetectionstatisticsData(queryForm.organizationId, StartDate.value, EndDate.value),
      postdetectionsummaryData(queryForm.organizationId, StartDate.value, EndDate.value),
      postwarningrecordsData(queryForm.organizationId, StartDate.value, EndDate.value),
      postWarningsummaryData(queryForm.organizationId, StartDate.value, EndDate.value),
      postwarninghourlystatisticsData(queryForm.organizationId, StartDate.value, EndDate.value),
      postThreesecondswarningordersData(queryForm.organizationId, StartDate.value, EndDate.value),
      getTesterThreeSecondsEvaluationData(queryForm.organizationId),
    ]
  )
  res2 = res[1].value
  res6 = res[6].value
  progressNum.value = getPercentage(res2, res6, 2)
  ElMessage.success("查询成功");

  // 重新检测轮询
  checkAndStartPoll()
}

const RealinitData = async () => {
  pageInfo.page = 1
  warnPage.page = 1
  // 静默判断，不弹窗
  if (!queryForm.organizationId) return

  if (queryForm.day == 1) {
    StartDate.value = getNowDate()
    EndDate.value = getNowDate()
  } else if (queryForm.day == 6) {
    if (queryForm.StartDate && queryForm.EndDate) {
      StartDate.value = queryForm.StartDate
      EndDate.value = queryForm.EndDate
    }
  } else if (queryForm.day == "year") {
    let time = getYearFirstLastDay()
    StartDate.value = time.firstDay
    EndDate.value = time.lastDay
  } else {
    StartDate.value = getRangeStartDate(getNowDate(), queryForm.day)
    EndDate.value = getNowDate()
  }

  let res = null
  let res2 = null
  let res6 = null
  res = await Promise.allSettled(
    [
      postchanneldetectionstatisticsData(queryForm.organizationId, StartDate.value, EndDate.value),
      postdetectionsummaryData(queryForm.organizationId, StartDate.value, EndDate.value),
      postWarningsummaryData(queryForm.organizationId, StartDate.value, EndDate.value),
      postwarninghourlystatisticsData(queryForm.organizationId, StartDate.value, EndDate.value),
      postThreesecondswarningordersData(queryForm.organizationId, StartDate.value, EndDate.value),
      getTesterThreeSecondsEvaluationData(queryForm.organizationId),
    ]
  )
  res2 = res[1].value
  res6 = res[5].value
  progressNum.value = getPercentage(res2, res6, 2)
}

const RefreshData = () => {
  if (selectList.value.length > 0) {
    queryForm.organizationId = selectList.value[0].id
  }
  pageInfo.page = 1
  warnPage.page = 1
  queryForm.day = "1"
  RealinitData()
  ElMessage.success("重置成功");
  checkAndStartPoll()
}

// 监听时间下拉切换，实时启停轮询
watch(
  () => queryForm.day,
  () => {
    checkAndStartPoll()
  }
)

onMounted(async () => {
  startConnection()

  if (scrollRef.value) {
    scrollRef.value.addEventListener('scroll', handleScroll)
  }
  if (warnScrollRef.value) {
    warnScrollRef.value.addEventListener('scroll', handleWarnScroll)
  }

  // 先加载下拉选项，赋值完成后再执行初始化查询+轮询，解决一进页面弹提示问题
  await getSelectList()
  checkAndStartPoll()
})

onUnmounted(async () => {
  // 销毁定时器
  stopPoll()

  scrollRef.value?.removeEventListener('scroll', handleScroll)
  warnScrollRef.value?.removeEventListener('scroll', handleWarnScroll)
  if (connection) {
    try {
      connection._reconnectDelay = null
      connection.off('ReceiveEvaluation')
      await connection.stop()
      connection = null
      console.log('✅ SignalR 已安全销毁')
    } catch (e) {
      connection = null
    }
  }
})
</script>

<style lang="scss" scoped>
.NoMore{
    font-size: 14px;
    color: #fff;
    text-align: center;
}
::v-deep svg > path:nth-child(2) {
  stroke: url(#myGradient);
}
:deep(.el-progress-circle__track) {
  stroke: #3E4E67 !important; 
}
:deep(.el-progress--line){
    width: 160px; 
}
.title_box{
    display: flex;
    align-items: center;
    padding: 10px;
    box-sizing: border-box;
}
.title{
    font-size: 18px;
    color: #fff;
    margin-left: 8px;
}
.middle_title{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
}
.title_center{
     margin-left: 8px;
     margin-right: 8px;
}
.val_12{
    margin-left: 40px;
    margin-right: 40px;
}
.percentage_left{
    margin-left: 10px;
    margin-right: 10px;
}
.percentage_right{
    margin-right: 10px;
}
:deep(.el-progress__text){
    left: 28Px !important;
}
.monitoringBigData_box{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.monitoringBigData{
    width: 100%;
    flex: 1;
    display: flex;
    overflow: hidden;
    .monitoringBigData_left{
        width: 400px;
        height: 100%;
        .left_top{
            width: 100%;
            border: 2px solid #32A2F8;
            height: 55%;
            display: flex;
            flex-direction: column;
            margin-bottom: 12px;
            box-sizing: border-box;
            border-radius: 10px 10px 0px 0px;
        }
        .left_bottom{
            width: 100%;
            border: 2px solid #32A2F8;
            height: 43%;
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
            border-radius: 0px 0px 10px 10px;
            .content{
                width: 100%;
                display: flex;
                justify-content: center;
                cursor: pointer;
                .content_val{
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      .val{
                          font-size: 24px;
                          font-weight: 600;
                          color: #1E73CB;
                          margin-bottom: 10px;
                      }
                      .text{
                        font-size: 16px;
                        color: #fff;
                      }
                }
            }
        }
    }
    .monitoringBigData_middle{
        flex:1;
        margin-left: 10px;
        margin-right: 10px;
        .middle_top{
            width: 100%;
            height: 55%;
            margin-bottom: 12px;
            box-sizing: border-box;
            position: relative;
            .top_progress{
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                .progress_circle{
                    width: 244Px;
                    height: 244Px;
                    background: #03386A;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    justify-content: center;
                    .circle_text{
                        color: #fff;
                        font-size: 16px;
                        margin-bottom: 20px;
                    }
                    .circle_val{
                        color: #fff;
                        font-size: 18px;
                    }
                    .circle_percentage{
                        display: flex;
                        align-items: center;
                        margin-bottom: 20px;
                        .percentage_val{
                            width: 40px;
                            height: 60px;
                            background: #0079DE;
                            font-weight: 600;
                            font-size: 30px;
                            border-radius: 4px;
                            color: #fff;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }
                        .val_wu{
                            font-size: 20px !important;
                        }
                    }
                }
            }
            .top_svg{
               position: absolute;
            }
        }
        .middle_bottom{
            width: 100%;
            height: 43%;
            border: 2px solid #32A2F8;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
            border-radius: 0px 0px 10px 10px;
        }
    }
    .monitoringBigData_right{
        width: 400px;
        height: 100%;
        border: 2px solid #32A2F8;
        box-sizing: border-box;
        border-radius: 10px;
        .box_list{
            height: 61%;
            box-sizing: border-box;
            .list_box{
               height: calc(100% - 50px);
               overflow: auto;
            }
            .list_item{
                  padding: 0px 10px 0px 20px;
                  box-sizing: border-box;
                .list{
                    background: #fff;
                    display: flex;
                    padding: 16px 0px 4px 10px;
                    box-sizing: border-box;
                    margin-bottom: 10px;
                    .list_left{
                        width: 180px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        .left_text{
                            font-size: 16px;
                        }
                    }
                    .list_right{
                         flex:1;
                        .right_val{
                            display: flex;
                            margin-bottom: 6px;
                            align-items: center;
                            .val_width{
                                width: 70px;
                                text-align: right;
                                font-size: 14px;
                            }
                            .val_size{
                                font-size: 14px;
                            }
                        }
                    }
            }
            }
        }
        .box_table{
            padding: 6px;
            height: 38%;
            box-sizing: border-box;
            .table_head{
                display: flex;
                background: #124E91;
                padding: 10px;
                box-sizing: border-box;
                justify-content: space-around;
                margin-bottom: 4px;
                color: #E6A23C;
                font-size: 14px;
                font-weight: 600;
                align-items: center;  
            }
            .table_head > div {
                    text-align: center;
                    flex: 1;
            }
            .table_content{
                overflow: hidden;
                overflow: auto;
                height: 88%;
                .content_item{
                    display: flex;
                    background: #03386A;
                    padding: 10px;
                    box-sizing: border-box;
                    align-items: center;
                    justify-content: space-around;
                    margin-bottom: 4px;
                    font-size: 14px;
                    color: #2CD7EF;
                }
                .content_item > div {
                    text-align: center;
                    flex: 1;
                }
            }
        }
    }
}
</style>